module.exports = __webpack_public_path__ + "static/logo-white-54343cc12a7213de1d4faacf8969ec3a.png";